export default function auth({ next, store, router }) {
	let access_token = store.getters['getAccessToken']
	let expires_in = store.getters['getExpiresIn']
	if(access_token === '' || new Date(expires_in) <= new Date()) {
		return router.push({
			name: 'login'
		})
	}
	return next()
}